import { template } from "lodash";
import { axiosBase, errorHandler } from "./axios";
import { getAccessToken } from "./helper";

const ALBUM_SEL_BASE = `/api/v1/album-selections`;

const authHeaders = () => ({ Authorization: `Bearer ${getAccessToken()}` });

const fetchAlbumWorkspace = ({ eventId, studioId }: { eventId: string; studioId: string }) =>
    axiosBase
        .get(`${ALBUM_SEL_BASE}/workspace/${eventId}`, {
            params: { studioId },
            headers: authHeaders(),
        })
        .then((r) => r.data)
        .catch(errorHandler);

const fetchAlbumSelectionSummary = ({ eventId, studioId }: { eventId: string; studioId: string }) =>
    axiosBase
        .get(`${ALBUM_SEL_BASE}/summary/${eventId}`, {
            params: { studioId },
            headers: authHeaders(),
        })
        .then((r) => r.data)
        .catch(errorHandler);

// Single call for all workflow transitions.
const changeAlbumStatus = ({
    eventId,
    selectionId,
    action,
    studioComment,
    comment,
    reviewDueDate,
    studioId,
    serviceId,
    templateId,
    itemIndex,
    selectedBlobNames,
}: {
    eventId: string;
    selectionId: string | null | undefined;
    action: string;
    studioComment?: string;
    comment?: string;
    reviewDueDate?: string | null;
    studioId?: string;
    serviceId?: string;
    templateId?: string;
    itemIndex?: number | null;
    selectedBlobNames?: string[];
}) =>
    axiosBase
        .patch(
            `${ALBUM_SEL_BASE}/status`,
            {
                eventId,
                selectionId,
                action,
                studioComment,
                comment,
                reviewDueDate,
                studioId,
                serviceId,
                templateId,
                itemIndex,
                selectedBlobNames,
            },
            { headers: authHeaders() },
        )
        .then((r) => r.data)
        .catch(errorHandler);

const listCuratedMedia = (payload: {
    eventId: string;
    studioId: string;
    serviceId: string;
    templateId: string;
    limit?: number;
    continuationToken?: string | null;
}) =>
    axiosBase
        .post(`${ALBUM_SEL_BASE}/curated-media`, payload, { headers: authHeaders() })
        .then((r) => r.data)
        .catch(errorHandler);

const validateCustomerAccess = (payload: {
    accessCode: string;
    emailOrPhoneNumber: string;
    reviewToken?: string | null;
}) =>
    axiosBase
        .post(`${ALBUM_SEL_BASE}/customer/validate`, payload)
        .then((r) => r.data)
        .catch(errorHandler);

const customerSubmitSelection = (payload: {
    selectionId: string;
    selectedBlobNames: string[];
    customerComment?: string;
}) =>
    axiosBase
        .post(`${ALBUM_SEL_BASE}/customer/submit`, payload)
        .then((r) => r.data)
        .catch(errorHandler);

const addRemainingPhotos = ({
    selectionId,
    studioSelectedBlobNames,
    eventId,
    studioId,
}: {
    selectionId: string;
    studioSelectedBlobNames: string[];
    eventId?: string;
    studioId?: string;
}) =>
    axiosBase
        .patch(
            `${ALBUM_SEL_BASE}/status`,
            {
                selectionId,
                action: "add_remaining",
                selectedBlobNames: studioSelectedBlobNames,
                eventId,
                studioId,
            },
            { headers: authHeaders() },
        )
        .then((r) => r.data)
        .catch(errorHandler);

const addToSelectedService = ({
    serviceId,
    selectedBlobUrls,
    eventId,
    studioId,
    templateId,
    itemIndex
}: {
    serviceId: string;
    selectedBlobUrls: { url: string; thumbnails: string }[];
    eventId: string;
    studioId: string;
    templateId:string;
    itemIndex:number;
}) =>
    axiosBase
        .patch(
            `${ALBUM_SEL_BASE}/add-to-selected`,
            {
                serviceId,
                selectedBlobUrls,
                eventId,
                studioId,
                templateId,
                itemIndex

            },
            { headers: authHeaders() },
        )
        .then((r) => r.data)
        .catch(errorHandler);

const addToBackgroundService = ({
    serviceId,
    selectedBlobNames,
    eventId,
    studioId,
    templateId,
     itemIndex
}: {
    serviceId: string;
    selectedBlobNames: string[];
    eventId: string;
    studioId: string;
   templateId:string;
    itemIndex:number;
}) =>
    axiosBase
        .post(
            `${ALBUM_SEL_BASE}/add-to-background`,
            {
                serviceId,
                selectedBlobNames,
                eventId,
                studioId,
                templateId,
                 itemIndex
            },
            { headers: authHeaders() },
        )
        .then((r) => r.data)
        .catch(errorHandler);

const listSelectedService = ({
    serviceId,
    eventId,
    studioId,
}: {
    serviceId: string;
    eventId: string;
    studioId: string;
}) =>
    axiosBase
        .get(`${ALBUM_SEL_BASE}/list-selected`, {
            params: {
                serviceId,
                eventId,
                studioId,
            },
            headers: authHeaders(),
        })
        .then((r) => r.data)
        .catch(errorHandler);

const eventAlbumSelectionService = {
    fetchAlbumWorkspace,
    fetchAlbumSelectionSummary,
    changeAlbumStatus,
    listCuratedMedia,
    validateCustomerAccess,
    customerSubmitSelection,
    addRemainingPhotos,
    addToSelectedService,
    addToBackgroundService,
    listSelectedService,
};

export default eventAlbumSelectionService;
